var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProgressStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2v2a7.994 7.994 0 014.674 13.594A8.013 8.013 0 0113 19.88v2c5.5-.6 9.45-5.54 8.85-11.03C21.33 6.19 17.66 2.5 13 2zm-2 0c-1.96.18-3.81.95-5.33 2.2L7.1 5.74c1.12-.9 2.47-1.48 3.9-1.68V2zM4.26 5.67A9.81 9.81 0 002.05 11h2c.19-1.42.75-2.77 1.64-3.9L4.26 5.67zM2.06 13c.2 1.96.97 3.81 2.21 5.33l1.42-1.43A8.002 8.002 0 014.06 13h-2zm5 5.37l-1.39 1.37A9.994 9.994 0 0011 22v-2a8.002 8.002 0 01-3.9-1.63h-.04zm1.52-1.57l.92-3.89-3-2.58 3.95-.37L12 6.35 13.55 10l3.95.33-3 2.58.92 3.89L12 14.74 8.58 16.8z"
  })));
}

export default "/images/progress_star.svg?18e3438f1aff0176eea61fe064a7ef1a";
export { SvgProgressStar as ReactComponent };